import { useState } from "react";

import Box from "@mui/material/Box";
import CardMedia from "@mui/material/CardMedia";
import Container from "@mui/material/Container";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Grid from "@mui/material/Grid2";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import CloudDiagramsDemo from "../../../assets/clouddiagrams/demo-preview.png";
import { NavatticEmbed } from "../../../Components/NavatticEmbed";

const IntroTour = () => {
  const [isDemoOpen, setIsDemoOpen] = useState(false);

  return (
    <Stack sx={{ backgroundColor: "general.backgroundDark" }}>
      <Container maxWidth="lg" sx={{ pt: 4, pb: 4 }}>
        <Grid container justifyContent="center">
          <Grid size={{ sm: 12, md: 8 }}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: "500",
                textAlign: "center",
              }}
              data-cy="clouddiagrams-demo-title"
            >
              Experience Cloud Diagrams in action
            </Typography>
            <Typography variant="body1" sx={{ m: "26px 0" }}>
              Take a self-guided tour to explore how Cloud Diagrams visualizes your cloud architecture in real-time,
              helping you pinpoint issues faster, track changes over time, and break down team knowledge silos.
            </Typography>
            <Box
              onClick={() => {
                setIsDemoOpen(true);
              }}
              sx={{ cursor: "pointer" }}
              data-cy="clouddiagrams-demo-preview"
            >
              <CardMedia
                component="img"
                image={CloudDiagramsDemo}
                alt="Cloud Diagrams Demo"
                sx={{
                  width: "100%",
                  height: "auto",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.15)",
                }}
              />
            </Box>
            {isDemoOpen && (
              <Dialog
                open={isDemoOpen}
                onClose={() => {
                  setIsDemoOpen(false);
                }}
                // fullWidth
                // maxWidth="lg"
                fullScreen
                sx={{
                  "& .MuiDialog-paper": {
                    height: "calc(100vh - 64px)",
                    width: "calc(100vw - 64px)",
                  },
                }}
              >
                <DialogContent>
                  <NavatticEmbed id="cm8q2aiuo003l03ky52yk1ihi" buttonText="Take a self-guided tour" />
                </DialogContent>
              </Dialog>
            )}
          </Grid>
        </Grid>
      </Container>
    </Stack>
  );
};

export default IntroTour;
